import Immutable from 'immutable'
import { createSelector } from 'reselect'

import {
  filterSignup,
  SignupWithExternalsRecord,
} from '../../../records/Signup'

export const getExternals = [
  state => state.product.get('products'),
  state => state.product.get('offers'),
  state => state.paymentToken.get('tokens'),
  state => state.client.get('clients'),
  state => state.billingGroup.get('groups'),
  state => state.partner.get('partners'),
  state => state.payment.get('payments'),
  state => state.user.get('users'),
  state => state.coupon.get('coupons'),
  (state, { sortBy = sortSignupsByDate('lastTransition', 'dateAdded') } = {}) => sortBy,
]

export function handleExternals(
  signups,
  products,
  offers,
  tokens,
  clients,
  billingGroups,
  partners,
  payments,
  users,
  coupons,
  sortBy,
) {
  if (sortBy) {
    signups = signups.sortBy(sortBy)
  }

  return signups
    .map((signup) => {
      const offer = offers.find(search => search.id === signup.offer)
      const extraOffer = offers.find(search => search.id === signup.extraOffer)
      const product = offer && products.find(search => search.id === offer.product)
      const token = signup.token
        ? tokens.find(search => search.uuid === signup.token)
        : null
      const client = signup.clientId
        ? clients.find(search => search.id === signup.clientId)
        : null
      const billingGroup = signup.billingGroupId
        ? billingGroups.find(search => search.id === signup.billingGroupId)
        : null
      const signupPayments = signup.payments.size > 0
        ? payments
        .filter(search => signup.payments.includes(search.reference))
        .sortBy(payment => payment.paymentDate.toDate())
        : Immutable.Set()
      const creator = signup.creator
        ? users.find(search => signup.creator === search.id)
        : null
      const partner = signup.partner
        ? partners.find(search => signup.partner === search.id)
        : null
      const user = signup.user
        ? users.find(search => signup.user === search.id)
        : null
      const coupon = signup.coupon
        ? coupons.find(search => signup.coupon === search.code)
        : null

      return new SignupWithExternalsRecord({
        billingGroup,
        client,
        coupon,
        creator,
        offer,
        extraOffer,
        partner,
        payments: signupPayments,
        product,
        signup,
        token,
        user,
      })
    })
}

export const selectSignup = createSelector(
  state => state.get('signups'),
  (state, id) => id,
  (signups, id) => signups.find(signup => signup.get('id') === id),
)

export const selectSignups = createSelector(
  state => state.signup.get('signups'),
  (state, filter) => filter,
  (signups, filter) => signups.filter(signup => filterSignup(signup, filter)),
)

export const selectSignupByReference = createSelector(
  state => state.get('signups'),
  (state, reference) => reference,
  (signups, reference) => signups.find(signup => signup.get('reference') === reference),
)

export const selectSignupsWithExternals = createSelector(
  [selectSignups, ...getExternals],
  handleExternals,
)

export const selectSignupWithExternals = createSelector(
  selectSignupsWithExternals,
  signups => signups.first(),
)

export function sortSignupsByDate(sortField, backupSort) {
  return (signup) => {
    const sortDate = signup[sortField] || signup[backupSort]

    return sortDate ? sortDate.toDate() : null
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/signup/selectors.js